<template>
  <div
    class="modal fade"
    id="addSlot"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h3 class="modal-title" id="myModalLabel">Create Slot</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="eventData">
          <form class="content-form">
            <div v-if="usersDetails">
              <div class="form-group">
                <label class="col-sm-3 control-label" htmlFor="roundType"
                  >{{
                    round.round_name == "Written Test"
                      ? "Schedulers"
                      : "Interviewers"
                  }}<span class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                  <select
                    multiple
                    id="interviewerpickerSlot"
                    v-model="round.interviewers_id"
                    class="selectpicker"
                    data-live-search="true"
                    data-width="100%"
                  >
                    <option
                      v-for="(interviewer, index) in usersDetails"
                      :key="index"
                      :value="interviewer.user_id"
                    >
                      {{ interviewer.first_name }} {{ interviewer.last_name }}
                    </option>
                  </select>
                  <p
                    v-if="
                      !$v.round.interviewers_id.required &&
                      $v.round.interviewers_id.$error
                    "
                    class="alert alert-danger"
                  >
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="round.round_name !== 'Written Test'">
              <label class="col-sm-3 control-label" htmlFor="template"
                >Template<span class="text-danger">*</span></label
              >
              <div class="col-sm-9">
                <select
                  multiple
                  id="slotTemplatepicker"
                  v-model="selected_form"
                  class="selectpicker"
                  data-live-search="true"
                  data-width="100%"
                  data-max-options="1"
                >
                  <option
                    v-for="(template, index) in activeTemplates"
                    :key="index"
                    :value="template"
                  >
                    {{ template.title }}
                  </option>
                </select>
                <p
                  v-if="
                    !$v.formValidate.selected_form.required &&
                    $v.formValidate.selected_form.$error
                  "
                  class="alert alert-danger mt-2 p-1"
                >
                  This field is required
                </p>
              </div>
            </div>

            <div
              class="form-group"
              v-if="round.round_name == 'Written Test' && instanceList.length"
              :key="'instance-' + round.round_name"
            >
              <label class="control-label col-sm-6" htmlFor="Instance"
                >Select Instance<span class="text-danger">*</span></label
              >
              <div class="col-sm-9">
                <select
                  v-model="selectedInstanceId"
                  id="instancePicker"
                  class="selectpicker"
                  data-width="100%"
                >
                  <option
                    v-for="instance in instanceList"
                    :value="instance.id"
                    :key="instance.id"
                  >
                    {{ instance.label }}
                  </option>
                </select>
                <p
                  v-if="
                    !$v.formValidate.selectedInstanceId.required &&
                    $v.formValidate.selectedInstanceId.$error
                  "
                  class="alert alert-danger mt-2 p-1"
                >
                  This field is required
                </p>
              </div>
            </div>
            <div
              class="form-group"
              v-if="selectedInstanceId && courseList.length"
            >
              <label class="control-label col-sm-3" htmlFor="course"
                >Select Course<span class="text-danger">*</span></label
              >
              <div class="col-sm-9">
                <select
                  id="coursePicker"
                  class="selectpicker"
                  data-width="100%"
                  v-model="selectedCourseId"
                >
                  <option
                    v-for="course in courseList"
                    :value="course.id"
                    :key="course.id"
                  >
                    {{ course.displayname }}
                  </option>
                </select>
                <p
                  v-if="
                    !$v.formValidate.selectedCourseId.required &&
                    $v.formValidate.selectedCourseId.$error
                  "
                  class="alert alert-danger mt-2 p-1"
                >
                  This field is required
                </p>
              </div>
            </div>
            <div class="form-group">
              <label class="required col-sm-3 control-label" htmlFor="date"
                >Date</label
              >
              <div class="col-sm-9">
                <date-picker
                  autocomplete="off"
                  v-model="round.date"
                  id="datePicker"
                  :config="minMaxConfig"
                  :minDate="
                    new Date(
                      'Mon Nov 07 2022 10:00:00 GMT+0530 (India Standard Time)'
                    )
                  "
                  @dp-hide="datePickerRequired"
                ></date-picker>
                <p v-if="datePickerFlag" class="alert alert-danger mt-2 p-1">
                  This field is required
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-9 d-flex">
                <div class="w-100 pr-2">
                  <label class="required ml-1 control-label" htmlFor="startTime"
                    >Start time (min-{{ minTime }})</label
                  >
                  <date-picker
                    autocomplete="off"
                    v-model="round.start_time"
                    :config="newConfigTime"
                    @dp-hide="timePickerStartRequired"
                  ></date-picker>
                  <h6
                    v-if="timePickerStartFlag"
                    class="alert alert-danger mt-2 p-1"
                  >
                    Required
                  </h6>
                </div>
                <div class="w-100 pl-2">
                  <label class="required ml-1 control-label" htmlFor="endTime"
                    >End time (max-{{ maxTime }})</label
                  >
                  <date-picker
                    autocomplete="off"
                    v-model="round.end_time"
                    :config="newConfigTime"
                    @dp-hide="timePickerEndRequired"
                  ></date-picker>
                  <h6
                    v-if="timePickerEndFlag"
                    class="alert alert-danger mt-2 p-1"
                  >
                    Required
                  </h6>
                </div>
              </div>
              <div class="col-sm-9">
                <h6
                  v-if="timePickerGreaterFlag"
                  class="alert alert-danger mt-2 px-1 py-1"
                >
                  End time should be greater than start time
                </h6>
              </div>
            </div>
            <div class="form-group">
              <label class="required col-sm-9 control-label" htmlFor="slotsM"
                >create multiple slots</label
              >
              <div class="col-sm-9 form-group">
                <input
                  name="slotCount"
                  v-model="round.slots_count"
                  class="position-relative form-control"
                  type="number"
                  data-vv-as="slot"
                  v-validate="'numeric|min_value:1|required'"
                />
                <p
                  v-if="errors.first('slotCount')"
                  class="alert alert-danger mt-2 p-1"
                >
                  Values must be positive only
                </p>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-dark" data-dismiss="modal">
            <strong>Cancel</strong>
          </button>
          <button
            :disabled="submitButtonEnable"
            type="button"
            class="btn btn-cp ml-2"
            @click="generateSlot"
          >
            <i class="fa fa-calendar fa-lg" aria-hidden="true"></i>
            Create Slot
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "../_api/index";
import datePicker from "vue-bootstrap-datetimepicker";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
/**
 * @memberOf module:ApplicantProfile
 * @namespace components.add_round_modal
 * @description Add round modal component
 */
export default {
  props: ["minDate", "maxDate", "minTime", "maxTime", "fetchEventSlots"],
  data() {
    return {
      selectedInstanceId: null,
      selectedCourseId: null,
      instanceList: [],
      courseList: [],
      selected_form: [],
      formTemplateChecker: false,
      round: {
        date: null,
        to_time: null,
        slots_count: 1,
        start_time: null,
        end_time: null,
        round_name: "",
        isMailed: false,
        round_result: null,
        interviewers_id: [],
      },
      interviewers: [101, 102, 103],
      reviewers: [101, 102, 103],
      config: {
        format: "DD MMMM YYYY",
        useCurrent: false,
        showClear: false,
        showClose: false,
        sideBySide: false,
      },
      configTime: {
        format: "HH:mm",
        useCurrent: false,
        showClear: false,
        showClose: false,
        sideBySide: false,
      },
      datePickerFlag: false,
      timePickerGreaterFlag: false,
      timePickerEndFlag: false,
      timePickerStartFlag: false,
      datePickerEndTimeFlag: false,
      isCoordinator: false,
      isStudent: false,
      interviewerChecker: false,
      isInterviewersTouched: false,
    };
  },
  components: {
    datePicker,
  },
  computed: {
    submitButtonEnable() {
      if (this.round.round_name === "Written Test") {
        return (
          !this.round.start_time ||
          !this.round.end_time ||
          !this.round.date ||
          this.round.end_time <= this.round.start_time ||
          this.round.interviewers_id.length === 0 ||
          this.round.slots_count < 1 ||
          !this.selectedCourseId ||
          !this.selectedInstanceId
        );
      } else {
        return (
          !this.round.start_time ||
          !this.round.end_time ||
          !this.round.date ||
          this.round.end_time <= this.round.start_time ||
          this.round.interviewers_id.length === 0 ||
          this.round.slots_count < 1 ||
          this.selected_form.length === 0
        );
      }
    },
    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description generate time picker range validation
     */
    newConfigTime() {
      if (!this.eventData) {
        return this.configTime;
      } else {
        const startDate = this.eventData.EventDetails.round_schedule;
        const endDate = this.eventData.EventDetails.round_schedule_end;
        const startDateHour = moment(startDate).hour();
        const startDateMinute = moment(startDate).minute();
        const endDateHour = moment(endDate).hour();
        const endDateMinute = moment(endDate).minute();
        const currentMin = moment();
        const currentMax = moment();
        currentMin
          .set({ h: startDateHour, m: startDateMinute })
          .subtract(1, "minutes");
        currentMax.set({ h: endDateHour, m: endDateMinute });
        const newConfig = {
          ...this.configTime,
          minDate: new Date(currentMin.format()),
          maxDate: new Date(currentMax.format()),
        };
        return newConfig;
      }
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description generate date picker range
     */
    minMaxConfig() {
      if (!this.eventData) {
        return this.config;
      } else {
        let passingDate = "";
        const startDate = this.eventData.EventDetails.round_schedule;
        moment(startDate).diff(moment(), "days");
        if (!moment(startDate).isBefore(new Date(), "day")) {
          passingDate = startDate;
        } else {
          passingDate = new Date().toISOString();
        }
        const newConfig = {
          ...this.config,
          enabledDates: this.getDatesBetween(
            passingDate,
            this.eventData.EventDetails.round_schedule_end
          ),
        };
        return newConfig;
      }
    },
    ...mapGetters({
      formTemplates: "$_form_template/getForms",
      eventData: "$_campus_recruitment/getEventData",
      campusMails: "$_applicants_data/fetchCampusMails",
      usersDetails: "$_applicant_profile/fetchUsersDetails",
      id: "$_applicant_profile/fetchID",
    }),
    activeTemplates() {
      return this.formTemplates.filter(
        (template) => template.status === "A" && template.formVersion.length
      );
    },
  },
  watch: {
    selectedInstanceId(value) {
      if (value) {
        api
          .getAllCourses(this.selectedInstanceId)
          .then((courseListResponse) => {
            api
              .filterUnassignedCourses(
                this.selectedInstanceId,
                courseListResponse.data
              )
              .then((filteredCourseListResponse) => {
                if (filteredCourseListResponse.data.length == 0) {
                  this.$store.dispatch(
                    "openSnackbar",
                    {
                      type: "danger",
                      message:
                        "All the courses are assigned for this instance as of now.",
                    },
                    {
                      root: true,
                    }
                  );
                } else this.courseList = filteredCourseListResponse.data;
                this.$nextTick(() => {
                  $("#coursePicker").selectpicker("refresh");
                });
              })
              .catch(() => {
                this.courseList = [];
                this.$store.dispatch(
                  "openSnackbar",
                  {
                    type: "danger",
                    message: "Problem in retrieving courses for this instance.",
                  },
                  {
                    root: true,
                  }
                );
                this.$nextTick(() => {
                  $("#coursePicker").selectpicker("refresh");
                });
              });
          })
          .catch(() => {
            this.courseList = [];
          });
      }
    },
    eventData: {
      handler(value) {
        if (value?.EventDetails) {
          this.round.round_name = value?.EventDetails.round_name;
        }
      },
      immediate: true,
      deep: true,
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @param {String} value
     * @description Marks if the round is interview round
     */
    "round.round_name"(value) {
      if (value === "Interview") {
        this.interviewerChecker = true;
        this.formTemplateChecker = true;
      }
    },
    "round.start_time"(value) {
      if (value) {
        if (this.round.end_time && value >= this.round.end_time)
          this.timePickerGreaterFlag = true;
        else this.timePickerGreaterFlag = false;
      }
    },
    "round.end_time"(value) {
      if (value) {
        if (this.round.start_time && value <= this.round.start_time)
          this.timePickerGreaterFlag = true;
        else this.timePickerGreaterFlag = false;
      }
    },
  },
  validations() {
    const round = {
      round_schedule: {
        required,
      },
    };
    round.interviewers_id = {
      required,
    };
    let formValidate = {};
    if (this.round.round_name === "Written Test") {
      formValidate.selectedInstanceId = {
        required,
      };
      formValidate.selectedCourseId = {
        required,
      };
    } else {
      formValidate = {
        selected_form: {
          required,
        },
      };
    }
    return {
      round,
      formValidate,
    };
  },
  methods: {
    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description generate Dates between given two dates
     */
    getDatesBetween(startDate, endDate) {
      startDate = new Date(startDate);
      endDate = new Date(endDate);

      let currentDate = new Date(startDate.getTime());
      const dates = [];
      while (currentDate <= endDate) {
        dates.push(new Date(currentDate));
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() + 1);
        currentDate = newDate;
      }
      return dates;
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description create slot for event
     */
    async generateSlot() {
      let formVersions = [];
      let selectedFormVersion = null;
      if (this.selected_form[0]?.formVersion.length > 0) {
        formVersions = this.selected_form[0].formVersion;
        selectedFormVersion = await formVersions.reduce((max, current) => {
          return current.id > max.id ? current : max;
        }, formVersions[0]);
      }
      api
        .createSlot({
          from_time: new Date(
            new Date(this.round.date + " " + this.round.start_time)
          ),
          to_time: new Date(
            new Date(this.round.date + " " + this.round.end_time)
          ),
          roundId: this.eventData.EventDetails.id,
          roundName: this.eventData.EventDetails.round_name,
          interviewerId: this.round.interviewers_id,
          slots_count:
            this.round.slots_count && this.round.slots_count > 0
              ? this.round.slots_count
              : 1,
          form_id: this.selected_form[0]?.id,
          formVersion_id: selectedFormVersion?.id,
          course_id: this.selectedCourseId ?? undefined,
          instance_id: this.selectedInstanceId,
        })
        .then(() => {
          this.fetchEventSlots();
          $("#addSlot").modal("hide");
          this.$store.dispatch(
            "openSnackbar",
            {
              type: "success",
              message: "Slots has been created!",
            },
            {
              root: true,
            }
          );
        })
        .catch((err) => {
          console.log("err", err);
          this.$store.dispatch(
            "openSnackbar",
            {
              type: "danger",
              message: err.response.data.message
                ? err.response.data.message
                : "Something went wrong",
            },
            {
              root: true,
            }
          );
        });
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description Required validation for date picker
     */
    datePickerRequired() {
      if (!this.round.date) {
        this.datePickerFlag = true;
      } else {
        this.datePickerFlag = false;
      }
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description Required validation for date picker
     */
    datePickerToRequired() {
      if (!this.round.to_time) {
        this.datePickerTimeFlag = true;
      } else {
        this.datePickerTimeFlag = false;
      }
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description Required validation for date picker
     */
    timePickerStartRequired() {
      if (!this.round.start_time) {
        this.timePickerStartFlag = true;
      } else {
        this.timePickerStartFlag = false;
      }
    },

    /**
     * @memberof module:CampusRecruitment.components.create-slot-modal
     * @description Required validation for date picker
     */
    timePickerEndRequired() {
      if (!this.round.end_time) {
        this.timePickerEndFlag = true;
      } else {
        this.timePickerEndFlag = false;
      }
    },
    getUsers() {
      this.$store.dispatch("$_applicant_profile/usersDetails");
    },
  },
  mounted() {
    if (this.eventData?.EventDetails) {
      this.round.round_name = this.eventData.EventDetails.round_name;
    }
    this.$store.dispatch("$_form_template/getAllFormMasters");
    $("#addSlot").on("hidden.bs.modal", () => {
      this.formTemplateChecker = false;
      this.round.date = null;
      this.round.slots_count = 1;
      this.round.interviewers_id = [];
      this.round.start_time = null;
      this.round.end_time = null;
      this.datePickerFlag = false;
      this.timePickerGreaterFlag = false;
      this.timePickerEndFlag = false;
      this.timePickerStartFlag = false;
      this.datePickerEndTimeFlag = false;
      this.interviewerChecker = false;
      this.isInterviewersTouched = false;
      this.selected_form = [];
      this.selectedInstanceId = null;
      this.selectedCourseId = null;
    });

    $("#interviewerpickerSlot").on("hidden.bs.select", () => {
      this.isInterviewersTouched = true;
    });

    $("#addSlot").on("show.bs.modal", () => {
      $("#slotTemplatepicker")
        .attr("title", "select template")
        .selectpicker("render");
      $("#instancePicker")
        .attr("title", "select instance")
        .selectpicker("render");
      $("#coursePicker").attr("title", "select course").selectpicker("render");
      $("#interviewerpickerSlot")
        .selectpicker("destroy")
        .attr(
          "title",
          this.round.round_name == "Written Test"
            ? "Select Schedulers"
            : "Select interviewers"
        )
        .selectpicker("render");
    });
  },

  created() {
    this.getUsers();
  },

  updated() {
    if (this.interviewerChecker) {
      let interviewpicker = document.getElementById("interviewerpickerSlot");
      if (interviewpicker != null) {
        $("#interviewerpickerSlot")
          .selectpicker("destroy")
          .attr(
            "title",
            this.round.round_name == "Written Test"
              ? "Select Schedulers"
              : "Select Interviewers"
          )
          .selectpicker("render");
      }
      this.interviewerChecker = false;
    }
    if (this.formTemplateChecker) {
      let formpicker = document.getElementById("slotTemplatepicker");
      if (formpicker != null) {
        $("#slotTemplatepicker")
          .attr("title", "select template")
          .selectpicker("render");
      }
      this.formTemplateChecker = false;
    }
    let instancePicker = document.getElementById("instancePicker");
    if (instancePicker != null) {
      $("#instancePicker")
        .attr("title", "select instance")
        .selectpicker("render");
    }
    let coursePicker = document.getElementById("coursePicker");
    if (coursePicker != null) {
      $("#coursePicker").attr("title", "select course").selectpicker("render");
    }
  },
  beforeDestroy() {
    $("#addSlot").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
  async beforeMount() {
    await api.getAllMoodleInstances().then((res) => {
      this.instanceList = res.data;
    });
  },
};
</script>

<style>
.bootstrap-datetimepicker-widget table td:not(.disabled),
.bootstrap-datetimepicker-widget table td:not(.disabled):hover {
  color: #007bff !important;
  margin: 10px;
}
</style>
